import {
	captureCampaignFromRoute,
	refreshCampaignActivity
} from '~/composables/adCampaign/utils';
import { refreshSessionActivity } from '~/composables/visitorIdentity/utils';

export default defineNuxtRouteMiddleware(to => {
	if (import.meta.client) {
		captureCampaignFromRoute(to);
		refreshCampaignActivity();
		refreshSessionActivity();
	}
});
